import React from 'react';
import {
    InfoCircleIcon,
    CheckCircleIcon,
    WarningCircleIcon,
    LightbulbIcon,
    AlertHexagonIcon,
    type SystemIconType,
} from '@fiverr-private/visuals';
import { type Types } from '@fiverr-private/theme';
import type { Variant } from './types';

export const VARIANT = {
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error',
    SUCCESS: 'success',
    NEUTRAL: 'neutral',
} as const;

export const VARIANTS_CONFIG: {
    [key in Variant]: {
        Icon: React.FC<SystemIconType>;
        backgroundColor: Types.ContainerProps['backgroundColor'];
        borderColor: Types.ContainerProps['borderColor'];
    };
} = {
    neutral: {
        Icon: LightbulbIcon,
        backgroundColor: 'grey_100',
        borderColor: 'grey_400',
    },
    info: {
        Icon: InfoCircleIcon,
        backgroundColor: 'blue_100',
        borderColor: 'blue_400',
    },
    warning: {
        Icon: WarningCircleIcon,
        backgroundColor: 'yellow_100',
        borderColor: 'yellow_400',
    },
    success: {
        Icon: CheckCircleIcon,
        backgroundColor: 'green_100',
        borderColor: 'green_400',
    },
    error: {
        Icon: AlertHexagonIcon,
        backgroundColor: 'red_100',
        borderColor: 'red_400',
    },
};

export const ALERT_TITLE_ID = 'AlertTitle';
export const ALERT_TEXT_ID = 'AlertText';
export const ALERT_ACTIONS_ID = 'AlertActions';
